exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:1100px){.link-box .screenPdf .section-control .section-zoom-area .zoom-out{margin:0 10px 0 0}.link-box .screenPdf .section-control .section-zoom-area .zoom-num{display:none}.link-box .screenPdf .section-control .section-rotate-area .rotate-ccw{margin:0 10px 0 0}}", ""]);

// exports
